import React from 'react';
import styled from '@emotion/styled';

interface ContentProps {
  children: React.ReactNode;
}

export const Content = ({ children }: ContentProps) => {
  return <ContentSection>{children}</ContentSection>;
};

const ContentSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  padding: 2px 0;
`;
